import { SqlitePageConfigurationPublicGetPaged } from "@/api/Sqlite";
import globalConfig from "../../public/globalConfigFriendly.json";

/**
 * 根据值找key
 * @param {*} map map
 * @param {*} description 描述
 * @returns
 */
export const findKeyByDescription = (map = {}, description = "") => {
  let res;
  Object.keys(map).forEach((key) => {
    const val = map[key];
    if (val === description) {
      res = key;
    }
  });
  return res;
};

/* 用户审核记录表status记录 */
export const userAuditRecordStatus = {
  0: "发起审核",
  1: "退回",
  2: "入库",
  3: "出库",
};

// 平台logo字典
export const platFormlogoImageMap = {
  1: {
    logoImg: "",
    alt: "竞价平台",
    platformName: "竞价平台",
    showName: true,
  },
  3301: {
    logoImg: "",
    alt: "广东弘烨项目管理有限公司线上采购一体化平台",
    platformName: "",
    showName: true,
  },
  3362: {
    logoImg: "",
    alt: "",
    platformName: "华格采购管理（广州）有限公司线上采购一体化平台",
    showName: true,
  },
  // 2260: {
  //   logoImg: '/images/logo.png',
  //   alt: '东南大学采购管理',
  //   platformName: '东南大学采购管理平台',
  //   showName: true
  // },
  // 2252: {
  //   logoImg: '/images/jsjkLogo.svg',
  //   alt: '江苏省疾病预防控制中心',
  //   platformName: '线上采购一体化平台',
  //   showName: true
  // },
  // 1: {
  //   logoImg: '/images/jsjkLogo.svg',
  //   alt: '江苏省疾病预防控制中心',
  //   platformName: '线上采购一体化平台',
  //   showName: true,
  //   link: 'http://z.choicelink.cn/jscdc/index.html'
  // },
  // 2249: {
  //   logoImg: '/images/logo.png',
  //   alt: '全流程电子招投标系统',
  //   platformName: '云采链综合演示平台',
  //   showName: true
  // },
  // 2109: {
  //   logoImg: '/images/logo.png',
  //   alt: '全流程电子招投标系统',
  //   platformName: '采联国际全流程平台',
  //   showName: true,
  //   showOperationGuide: true,
  //   operationGuideDownloadUrl: {
  //     // 采购人: '',
  //     // 代理机构: '',
  //     供应商: 'https://choicelink-public.oss-cn-shenzhen.aliyuncs.com/eea258ecb2074a368c5cede5849d0d28.docx'
  //     // 专家: ''
  //   }
  // },
  // 2032: {
  //   logoImg: '/images/logo.png',
  //   alt: '云采链',
  //   platformName: '',
  //   showName: false
  // }
};

export async function getPlatFormlogoImageMap(tenantId) {
  if (!tenantId) throw new Error("缺少平台ID");
  // 获取平台配置数据
  const { result } = await SqlitePageConfigurationPublicGetPaged({
    filter: `tenantId == "${tenantId}" && templateId == "${globalConfig.setting.templateId.platformConfig}"`,
  });
  const platformConfigItem = JSON.parse(result.items[0].content);
  const res = {
    logoImg: "",
    alt: "",
    platformName: platformConfigItem.platformCompanyName,
    showName: true,
  };
  return res;
}
